export default "__VITE_ASSET__BEjZVRYH__"